export default "__VITE_ASSET__BRvwLVTw__"